/* tslint:disable */
/* eslint-disable */
/**
 * AGAIN-AGAIN API
 * backend api for tracking container movement for again-again
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ContainerCategory,
    ContainerCategoryFromJSON,
    ContainerCategoryFromJSONTyped,
    ContainerCategoryToJSON,
    ContainerTypeVersion,
    ContainerTypeVersionFromJSON,
    ContainerTypeVersionFromJSONTyped,
    ContainerTypeVersionToJSON,
    TierEnum,
    TierEnumFromJSON,
    TierEnumFromJSONTyped,
    TierEnumToJSON,
} from './';

/**
 * 
 * @export
 * @interface ContainerType
 */
export interface ContainerType {
    /**
     * 
     * @type {string}
     * @memberof ContainerType
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerType
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerType
     */
    subtitle: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerType
     */
    containerMapThumbnail: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerType
     */
    containerShelfThumbnail: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerType
     */
    containerDetailImage: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerType
     */
    description: string;
    /**
     * 
     * @type {ContainerCategory}
     * @memberof ContainerType
     */
    containerCategory: ContainerCategory;
    /**
     * 
     * @type {ContainerTypeVersion}
     * @memberof ContainerType
     */
    currentVersion: ContainerTypeVersion;
    /**
     * 
     * @type {Array<ContainerTypeVersion>}
     * @memberof ContainerType
     */
    containerVersions: Array<ContainerTypeVersion>;
    /**
     * 
     * @type {TierEnum}
     * @memberof ContainerType
     */
    tier: TierEnum;
    /**
     * 
     * @type {number}
     * @memberof ContainerType
     */
    volumeSize: number;
    /**
     * 
     * @type {number}
     * @memberof ContainerType
     */
    lateFee: number;
    /**
     * 
     * @type {string}
     * @memberof ContainerType
     */
    readonly bondRequired: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerType
     */
    readonly onShelf: string;
}

export function ContainerTypeFromJSON(json: any): ContainerType {
    return ContainerTypeFromJSONTyped(json, false);
}

export function ContainerTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContainerType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'subtitle': json['subtitle'],
        'containerMapThumbnail': json['container_map_thumbnail'],
        'containerShelfThumbnail': json['container_shelf_thumbnail'],
        'containerDetailImage': json['container_detail_image'],
        'description': json['description'],
        'containerCategory': ContainerCategoryFromJSON(json['container_category']),
        'currentVersion': ContainerTypeVersionFromJSON(json['current_version']),
        'containerVersions': ((json['container_versions'] as Array<any>).map(ContainerTypeVersionFromJSON)),
        'tier': TierEnumFromJSON(json['tier']),
        'volumeSize': json['volume_size'],
        'lateFee': json['late_fee'],
        'bondRequired': json['bond_required'],
        'onShelf': json['on_shelf'],
    };
}

export function ContainerTypeToJSON(value?: ContainerType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'subtitle': value.subtitle,
        'container_map_thumbnail': value.containerMapThumbnail,
        'container_shelf_thumbnail': value.containerShelfThumbnail,
        'container_detail_image': value.containerDetailImage,
        'description': value.description,
        'container_category': ContainerCategoryToJSON(value.containerCategory),
        'current_version': ContainerTypeVersionToJSON(value.currentVersion),
        'container_versions': ((value.containerVersions as Array<any>).map(ContainerTypeVersionToJSON)),
        'tier': TierEnumToJSON(value.tier),
        'volume_size': value.volumeSize,
        'late_fee': value.lateFee,
    };
}


